<template>
  <ul class="sidebar-menu">
    <li class="header">MENU DE NAVEGAÇÃO</li>
    <router-link tag="li" class="pageLink" to="/">
      <a>
        <i class="fa fa-search"></i>
        <span class="page">Consulta</span>
      </a>
    </router-link>
    
    <router-link v-if="this.$store.state.user.nivel == 'administrador'" tag="li" class="pageLink" to="/empresas">
      <a>
        <i class="fa fa-bank"></i>
        <span class="page">Empresas</span>
      </a>
    </router-link>

    <router-link  v-if="this.$store.state.user.nivel == 'administrador'" tag="li" class="pageLink" to="/usuarios">
      <a>
        <i class="fa fa-users"></i>
        <span class="page">Usuários</span>
      </a>
    </router-link>

    <router-link  v-if="this.$store.state.user.nivel == 'administrador'" tag="li" class="pageLink" to="/fechamento">
      <a>
        <i class="fa fa-money"></i>
        <span class="page">Fechamento</span>
      </a>
    </router-link>    
  </ul>
</template>
<script>

  export default {
    name: 'SidebarMenu',
    data: () => ({

    }),
    methods: {
     isVisible (permissao) {
      if (this.$acl.get.indexOf(permissao) > -1) {
        return true;
      }
      return false;
    }
  }
}
</script>
<style>
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
  }

  .sidebar-menu li.active>a>.fa-angle-left, .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: .2s;
    animation-fill-mode: forwards;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?01b4a878